// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalForm_backdrop__V3kuT","modal":"ModalForm_modal__DJpbx","form":"ModalForm_form__-ZR-1","input":"ModalForm_input__rau7I","button":"ModalForm_button__fymGA"};